// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PaymentElementAppearanceDemo: MarkdocTagRegistration = {
  tag: 'payment-element-appearance-demo',
  component: 'PaymentElementAppearanceDemo',
  description:
    'Display a interactive Payment Element demo for different appearance theme',
};
